<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <b-card-header class="card-header-icon card-header-info">
                    <div class="card-icon" v-b-toggle.filter>
                        <i class="material-icons">show_chart</i>
                    </div>
                    <b-card-title>Propostas</b-card-title>
                </b-card-header>
                <b-card-body>
                    <b-form @submit="onSubmit" @reset="onReset">
                        <div class="row">
                            <div v-if="auth !== undefined && auth.profile !== undefined && auth.profile.type_profile_id !== '4'" class="col-md-4">
                                <div class="form-group bmd-form-group is-filled">
                                    <label for="salesman" class="bmd-label-floating">Vendedor</label>
                                    <model-list-select 
                                        class="form-control"
                                        :list="salesmans"     
                                        option-value="id"
                                        option-text="name"
                                        v-model="form.salesman_id">
                                    </model-list-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group bmd-form-group is-filled"
                                     v-bind:class="{'has-danger' : validation.interval != '' }">
                                    <label for="interval" class="bmd-label-floating">Intervalo Data</label>
                                    <date-picker
                                        range
                                        v-model="form.interval"
                                        lang="pt-br"
                                        format="DD/MM/YYYY"
                                        placeholder="Escolha uma data"
                                        :not-after="form.end_at"
                                        ></date-picker>
                                    <label v-if="validation.interval != ''" id="interval-error" class="error" for="interval">{{ validation.interval }}</label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                                <button type="submit" class="btn btn-fill btn-rose">Filtrar</button>
                            </div>
                        </div>
                    </b-form>
                    <hr />
                    <div v-if="items.length > 0" class="row">
                        <div class="col-md-6">
                            <div class="table-responsive">
                                <table class="table b-table table-striped table-hover">
                                    <thead>
                                        <tr role="row">
                                            <th role="columnheader"
                                                scope="col">
                                                Tipos
                                            </th>
                                            <th role="columnheader"
                                                scope="col">
                                                Quantidade
                                            </th>
                                            <th role="columnheader"
                                                scope="col">
                                                Valor
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr role="row" v-for="item in items">
                                            <td rolw="cell">{{ item.type }}</td>
                                            <td rolw="cell">{{ item.quantity }}</td>
                                            <td rolw="cell">R$ {{ item.value | price }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <apexchart height="380" type="bar" :options="options" :series="series"></apexchart>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-md-12">
                            <h4>Não foram encontrados dados para o Cockpit!</h4>
                        </div>
                    </div>
                </b-card-body>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ProposalsService from '@/services/modules/proposals.service';
    import UserService from '@/services/modules/users.service';

    export default {
        computed: {
            auth: {
                get() {
                    var user = this.$store.state.auth.user
                    return user
                }
            }
        },
        methods: {
            processCockpit(_items) {
                let self = this;

                self.items = [];
                self.options.xaxis.categories = [];
                self.series = [
                    {
                        name: 'Quantidade',
                        data: []
                    }
                ];

                if (_items.billeds.quantity > 0
                        || _items.canceleds.quantity > 0
                        || _items.contemplateds.quantity > 0
                        || _items.news.quantity > 0) {
                    self.processItems(_items);
                }
            },
            processItems(_items) {
                let self = this;
                let data = [];

                self.options.xaxis.categories.push("Propostas Novas");
                data.push(_items.news.quantity);
                self.items.push({
                    type: "Propostas Novas",
                    quantity: _items.news.quantity,
                    value: _items.news.value
                });
                self.options.xaxis.categories.push("Propostas Contempladas");
                data.push(_items.contemplateds.quantity);
                self.items.push({
                    type: "Propostas Contempladas",
                    quantity: _items.contemplateds.quantity,
                    value: _items.contemplateds.value
                });
                self.options.xaxis.categories.push("Propostas Faturadas");
                data.push(_items.billeds.quantity);
                self.items.push({
                    type: "Propostas Faturadas",
                    quantity: _items.billeds.quantity,
                    value: _items.billeds.value
                });
                self.options.xaxis.categories.push("Propostas Canceladas");
                data.push(_items.canceleds.quantity);
                self.items.push({
                    type: "Propostas Canceladas",
                    quantity: _items.canceleds.quantity,
                    value: _items.canceleds.value
                });

                self.series = [
                    {
                        name: 'Quantidade',
                        data: data
                    }
                ];
            },
            getData() {
                const form = this.form;
                const validation = this.validation;
                const self = this;
                let valid = true;

                validation.interval = "";
                if (form.interval[0] === null || form.interval[1] === null) {
                    valid = false;
                    validation.interval = "Favor informar o intervalo!";
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const cockpit = ProposalsService.getCockpit(form.interval[0], form.interval[1], form.salesman_id);

                    cockpit.then(function (_leads) {
                        self.$root.$emit("onLoading");
                        self.processCockpit(_leads);
                    });

                    cockpit.catch(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.error("Falha na comunicação com a API, não foi possivel recuperar os dados do Cockpit de Propostas, tente novamente mais tarde!");
                    });
                }
            },
            async getSalesman() {
                var self = this;

                var params = "branch_id=" + self.$store.state.auth.user.branch_id + "&type_profile_id=" + UserService.typeProfiles.salesman
                const response = UserService.all(params);

                response.then(function (_users) {
                    var salesmans = _users;
                    salesmans.push({
                        id: '',
                        name: 'Todos'
                    });
                    self.salesmans = salesmans;

                    self.$root.$emit("onLoading");
                    self.onReset()
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'teams.index'});
                });
            },
            onReset(_evt) {
                if (_evt !== undefined) {
                    _evt.preventDefault()
                }

                this.form.interval = [Vue.moment().subtract(30, "days"), Vue.moment()];
                this.onSubmit();
            },
            onSubmit(_evt) {
                if (_evt !== undefined) {
                    _evt.preventDefault()
                }
                let self = this;
                self.getData();
            }
        },
        data() {
            return {
                form: {
                    end_at: Vue.moment().add(180, "days"),
                    interval: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    salesman_id: ''
                },
                items: [],
                options: {
                    chart: {
                        id: 'cockpit-proposals'
                    },
                    xaxis: {
                        categories: []
                    }
                },
                salesmans: [],
                series: [
                    {
                        name: 'Quantidade',
                        data: []
                    }
                ],
                validation: {
                    interval: ""
                }
            }
        },
        mounted() {
            this.getSalesman();
        }
    };
</script>
